import { render, staticRenderFns } from "./DiscussDetail.vue?vue&type=template&id=0f613f9d&scoped=true"
import script from "./DiscussDetail.vue?vue&type=script&lang=js"
export * from "./DiscussDetail.vue?vue&type=script&lang=js"
import style0 from "./DiscussDetail.vue?vue&type=style&index=0&id=0f613f9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f613f9d",
  null
  
)

export default component.exports